<template>
    <div class="full-height">
        <div class="report-selector">
            <!-- Label para el select -->
            <label for="reportSelect">Seleccionar Reporte</label>
            <select
                id="reportSelect"
                v-model="selectedReport"
                @change="updateIframe"
            >
                <option v-for="(url, name) in reports" :value="url" :key="name">
                    {{ name }}
                </option>
            </select>
        </div>

        <iframe
            title="Report Section"
            width="100%"
            height="900px"
            :src="iframe"
            frameborder="0"
            allowFullScreen="true"
        ></iframe>
    </div>
</template>

<script>
export default {
    data() {
        return {
            iframe: "https://app.powerbi.com/view?r=eyJrIjoiODA1YzI4NjktMGUxOS00ZDNmLThiNmYtNDE0ZTgzODVkNGNmIiwidCI6ImVkZDJlZTZlLWE2ZWEtNDgxYi1hZmMzLWVlMTAwYjZiMjkxZiJ9",
            selectedReport:
                "https://app.powerbi.com/view?r=eyJrIjoiODA1YzI4NjktMGUxOS00ZDNmLThiNmYtNDE0ZTgzODVkNGNmIiwidCI6ImVkZDJlZTZlLWE2ZWEtNDgxYi1hZmMzLWVlMTAwYjZiMjkxZiJ9",
            reports: {
                SBO: "https://app.powerbi.com/view?r=eyJrIjoiN2E4Y2QyM2QtZDZmMi00ZjRlLThjYjktODU2ZWMxZGRjMTdlIiwidCI6ImVkZDJlZTZlLWE2ZWEtNDgxYi1hZmMzLWVlMTAwYjZiMjkxZiJ9",
                Devoluciones:
                    "https://app.powerbi.com/view?r=eyJrIjoiODA1YzI4NjktMGUxOS00ZDNmLThiNmYtNDE0ZTgzODVkNGNmIiwidCI6ImVkZDJlZTZlLWE2ZWEtNDgxYi1hZmMzLWVlMTAwYjZiMjkxZiJ9",
            },
        };
    },
    methods: {
        updateIframe() {
            this.iframe = this.selectedReport;
        },
    },
};
</script>

<style scoped>
.report-selector {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-right: 10px;
}

.report-selector label {
    margin-top: 11px;
    margin-bottom: 5px; /* Espacio entre el label y el select */
    color: #007bff; /* Color para hacer que el label resalte */
    font-weight: bold; /* Hacer que el texto sea más grueso */
}

.report-selector select {
    color: rgb(37, 36, 35);
    box-sizing: border-box;
    padding: 0 0.5em 0 0.5em;
    font-size: inherit;
    border: 2px solid #007bff;
    background-color: #e7f1ff;
    height: 40px;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.report-selector select:focus,
.report-selector select:hover {
    border-color: #0056b3;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
</style>
